module.exports = __webpack_public_path__ + "static/media/dominny.e6484bc3.svg";